import page0 from "./_0_job-order-cover-sheet";
import page1 from "./_1_preliminary-questions";
import page2 from "./_2_job-offer-information";
import page3 from "./_3_minimum-job-qualifications-requirements";
import page4 from "./_4_place-of-employment-information";
import page5 from "./_5_housing-information";
import page6 from "./_6_additional_material_terms_and_conditions";
import page7 from "./_7_referral-and-hiring-instructions";
import page8 from "./_8_conditions-of-employment-and-assurances";
import page9 from "./_9_addendum_A-crops";
import page10 from "./_10_addendum_B(C)_additional_agricultural_business";
import page11 from "./_11_addendum_B(D)_additional_housing_location";
import page12 from "./_12_addendum-c";
import page13 from "./_13_state_workface_agency";

const form_meta = {
  code: "Form ETA-790 / Form ETA-790A",
  name: "H-2A Agricultural Clearance Order",
  version: "Processed under 2024 H-2A Farmworker Protection Final Rule",
};

const form_nav = [
  {
    name: "Job Order Cover Sheet",
    symbol: "document",
  },
  {
    name: "Preliminary Questions",
    prefix: "PQ",
    symbol: "list",
  },
  {
    name: "Job Offer Information",
    prefix: "A",
  },
  {
    name: "Minimum Job <br/>Qualifications/Requirements",
    prefix: "B",
  },
  {
    name: "Place of Employment Information",
    prefix: "C",
  },
  {
    name: "Housing Information",
    prefix: "D",
  },
  {
    name: "Additional Material Terms and Conditions of the Job Offer",
    prefix: "E",
  },
  {
    name: "Referral and Hiring Instructions",
    prefix: "F",
  },
  {
    name: "Conditions of Employment and Assurances for H-2A Agricultural Clearance Orders",
    prefix: "G",
  },
  {
    name: "Addendum A - Additional Crops and/or Agricultural Activities",
    prefix: "ADD <br/>A",
    classes: "label-prefix-appx",
    relevantValue: "eta_790a_addendum_a",
  },
  {
    // Section C
    name: "Addendum B - Additional Agricultural Business and Place of Employment Information",
    prefix: "ADD <br/>B",
    classes: "label-prefix-appx",
    relevantValue: "eta_790a_addendum_b_employment",
  },
  {
    // Section E
    name: "Addendum B - Additional <br/>Housing Location",
    prefix: "ADD <br/>B",
    classes: "label-prefix-appx",
    relevantValue: "eta_790a_addendum_b_housing",
  },
  {
    name: "Addendum C - Material Terms<br/> and Conditions of the Job Offer",
    prefix: "ADD <br/>C",
    classes: "label-prefix-appx",
    relevantValue: "eta_790a_addendum_c",
  },
  {
    name: "State Workforce Agency (SWA) <br/>Selection",
    prefix: "SWA",
    classes: "label-prefix-appx",
  },
];

const uiSchema = [
  page0,
  page1,
  page2,
  page3,
  page4,
  page5,
  page6,
  page7,
  page8,
  page9,
  page10,
  page11,
  page12,
  page13,
];

export { form_meta, form_nav };

export default uiSchema;
